export default __webpack_public_path__ + "static/media/therapyIcon.d11244b5.svg";